import { KatapultElement, html } from '../../mixins/katapult-element.js';
import '../style-modules/flex';
import '../style-modules/katapult-scrollbars.js';
import '../katapult-elements/katapult-dialog.js';
import '../katapult-elements/katapult-button.js';
/* Set up zero-md with light theme only */
import ZeroMd, { STYLES } from 'zero-md';
customElements.define(
  'zero-md',
  class extends ZeroMd {
    async load() {
      await super.load();
      this.template = STYLES.preset('light');
    }
  }
);

class ReleaseNotesDialog extends KatapultElement {
  static get template() {
    return html`
      <katapult-dialog id="dialog" entry-animation="scale-up-animation" modal draggable closebutton width="800" maxheight="800">
        <span slot="title">Release Notes</span>
        <div>
          <zero-md id="changelog" src="/CHANGELOG.md" on-zero-md-rendered="_filterChangelog"></zero-md>
        </div>
        <!-- <div slot="buttons" flex style="width: 100%;">
          <template is="dom-if" if="[[!showFullChangelog]]">
            <katapult-button grow on-click="_showAll">Show All</katapult-button>
          </template>
        </div> -->
      </katapult-dialog>
    `;
  }

  static get is() {
    return 'release-notes-dialog';
  }

  static get properties() {
    return {
      // Public Properties.
      uid: {
        type: String
      },
      userGroup: {
        type: String
      },
      codeVersion: {
        type: String
      },
      name: {
        type: String
      },
      showFullChangelog: {
        type: Boolean,
        value: false
      },
      errorLoadingChangelog: {
        type: Boolean,
        value: false
      },
      lastViewedReleaseNotes: {
        type: String,
        value: null
      }
    };
  }
  static get observers() {
    return [
      '_updateLastVersionRef(userGroup, uid)',
      '_getLastVersion(_userDataRef)',
      '_checkForNewVersion(codeVersion, lastVersion)',
      '_checkForNewReleaseNotes(codeVersion, lastViewedReleaseNotes)',
      '_filterChangelog(showFullChangelog)'
    ];
  }
  ready() {
    super.ready();
  }

  // Public Methods.
  open() {
    this._filterChangelog();
    this.$.dialog.open();

    // As long as we're in production, update the last viewed release notes.
    if (this.codeVersion != 'VERSION') {
      this._userDataRef?.child('last_viewed_release_notes').set(this.codeVersion);
    }

    // Update the local variable when the dialog has closed.
    this.$.dialog.addEventListener('closed', () => {
      this.lastViewedReleaseNotes = this.codeVersion;
    });
  }

  // Private Methods.
  async _getLastVersion() {
    if (!this._userDataRef) return;
    this.lastVersion = await this._userDataRef
      ?.child('last_version')
      .once('value')
      .then((s) => s.val());
    // Get the last viewed release notes. Set to 0.0 if it doesn't exist.
    this.lastViewedReleaseNotes = await this._userDataRef
      ?.child('last_viewed_release_notes')
      .once('value')
      .then((s) => s.val() ?? '0.0');
  }
  _calVerToPartialMdId(calVer) {
    return `v${calVer?.slice(0, 5).replace('.', '')}`;
  }
  _checkForNewVersion(codeVersion, lastVersion) {
    // Don't run the checks if we're in a dev environment.
    if (codeVersion == 'VERSION' || !codeVersion || !lastVersion) return;

    // If the current version is greater than the last version, show the dialog.
    if (this._compareVersions(codeVersion, lastVersion) > 0) {
      this._userDataRef?.child('last_version').set(codeVersion);
    }
  }
  _checkForNewReleaseNotes(codeVersion, lastViewedReleaseNotes) {
    // Don't run the checks if we're in a dev environment.
    if (codeVersion == 'VERSION' || !codeVersion || !lastViewedReleaseNotes) return;

    // If we've never viewed release notes or haven't since the new version, notify the app that a new version has been detected.
    if (this._compareVersions(codeVersion, lastViewedReleaseNotes) > 0) {
      this.fire('release-notes-update', { version: codeVersion }, true);
    }
  }
  _compareVersions(a, b) {
    const [aYear, aMonth] = a.split('.').map((x) => parseInt(x));
    const [bYear, bMonth] = b.split('.').map((x) => parseInt(x));

    if (aYear > bYear) return 1;
    if (aYear < bYear) return -1;
    if (aMonth > bMonth) return 1;
    if (aMonth < bMonth) return -1;
    return 0;
  }
  _filterChangelog() {
    // TODO (03-02-2023): The logic here is shaky. It wasn't handling all cases correctly, and I ran out of time.
    return;

    const changelogShadowRoot = this.$.changelog.shadowRoot;

    // Show all if no break id is set.
    if (this.showFullChangelog || this.codeVersion == this.lastViewedReleaseNotes) {
      changelogShadowRoot.querySelectorAll(`[hidden]`).forEach((el) => el.removeAttribute('hidden'));
    }
    // Hide all elements after the break id.
    else {
      const partialMdId = this._calVerToPartialMdId(this.lastViewedReleaseNotes);
      const lastVersionId = this.$.changelog.shadowRoot.querySelector(`h1[id$="${partialMdId}"]`)?.id;
      const breakHeader = changelogShadowRoot.querySelector(`h1#${lastVersionId}`);
      const siblings = changelogShadowRoot.querySelectorAll(`h1#${lastVersionId} ~ *`);
      const elements = [breakHeader, ...siblings];
      elements.forEach((el) => el?.setAttribute('hidden', ''));
    }
  }
  _showAll() {
    this.showFullChangelog = true;
  }
  _updateLastVersionRef(userGroup, uid) {
    if (!userGroup || !uid) this._userDataRef = null;
    else this._userDataRef = FirebaseWorker.ref(`photoheight/company_space/${userGroup}/user_data/${uid}`);
  }
}

window.customElements.define(ReleaseNotesDialog.is, ReleaseNotesDialog);
